import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    NgSwitch,
    NgSwitchCase,
    MatButton,
    NgSwitchDefault
  ]
})
export class ConfirmDialogComponent {
  title: string;
  message: string;
  type = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    if (!data) {
      return;
    }
    if (data.title) {
      this.title = data.title;
    }

    if (data.message) {
      this.message = data.message;
    }

    if (data.type) {
      this.type = data.type;
    }
  }
}
